<template lang="pug">
  <transform :transform='transform' :parent-transform='parentTransform' :render-tools='renderTools' :parent-container='parentContainer' :partutil='partutil' :key='transform.id' >
    <template #holder='data'>
      <on-mount @mount='store(data)' @unmount='remove(data)' />
    </template>
  </transform>
</template>
<script>
import OnMount from '@edit/atoms/OnMount.vue';
export default {
  props:{
    transform:{
      required:true,
      type:Object
    },
    parentTransform:{
      required:true,
      type:Object
    },
    parentContainer:{
      required:true,
      type:Object
    },
    renderTools:{
      required:true,
      type:Object
    },
    partutil:{
      required:true,
      type:Object
    }
  },
  data() {
    return {
      datas:[]
    }
  },
  components: {
    Transform: () => import('./Transform.vue'),
    OnMount
  },
  beforeDestroy() {
  },
  mounted() {
    console.log('clone',this.transform.id);
  },
  methods:{
    store(data) {
      this.datas.push(data);
    },
    remove(data) {
      this.datas = this.datas.filter( (d) => {
        return d !== data;
      });
    }
  },
  watch:{
    'transform.transform.pos':{
      handler(nv) {
        console.log('pos updated', JSON.stringify(this.transform.transform.pos), this.transform.id);
        this.datas.forEach( (d) => {
          this.renderTools.addToUpdateBatch(d.holder, d.transform.id);
        });
      },
      deep:true
    }

  }
}
</script>
